import timer_gen_2 from '@devices/settings/device_settings/timer_gen_2.js';
import schedule_gen_2 from '@devices/settings/device_settings/schedule_gen_2.js';
import webhooks_gen_2 from '@devices/settings/device_settings/webhooks_gen_2.js';
import scripts_gen_2 from '@devices/settings/device_settings/scripts_gen_2.js';
import networks_gen_2_pro from '@devices/settings/device_settings/networks_gen_2_pro.js';
import virtual_components_pro_devices from '@devices/settings/device_settings/virtual_components_pro_devices.js';
import safety_gen_2_auto_recovery_under_voltage from '@devices/settings/device_settings/safety_gen_2_auto_recovery_under_voltage.js';
import app_setting_pm_gen_2 from '@devices/settings/device_settings/app_setting_pm_gen_2.js';
import share from '@devices/settings/device_settings/share.js';
import multi_settings_gen_2 from '@devices/settings/device_settings/multi_settings_gen_2.js';
import roller_pro_pm_settings_gen_2 from '@devices/settings/common_settings/roller_pro_pm_settings_gen_2.js';
import bluetooth_bt_home_control_gen_2 from '@devices/settings/device_settings/bluetooth_bt_home_control_gen_2';
import addon_sensors, { addon_pro_devices } from '@devices/settings/device_settings/addon_sensors';
import bluetooth_gen_2 from '@devices/settings/device_settings/bluetooth_gen_2.js';

export default {
	name: 'ShellyPro2PM',
	friendly_name: 'Pro 2 PM',
	family: 'relay',
	isPM: true,
	addons: addon_pro_devices,
	modes: {
		relay: {
			availableViews: ['basic', 'advanced'],
			channels: 2,
			notifications: [
				'offline',
				'device_problem',
				'overpower',
				'overvoltage',
				'forgotten_lights',
				'overtemperature',
			],
			settings: [
				timer_gen_2,
				schedule_gen_2,
				webhooks_gen_2,
				addon_sensors,
				scripts_gen_2,
				networks_gen_2_pro,
				bluetooth_bt_home_control_gen_2,
				virtual_components_pro_devices,
				safety_gen_2_auto_recovery_under_voltage,
				app_setting_pm_gen_2,
				share,
				multi_settings_gen_2,
			],
		},
		roller: {
			availableViews: ['advanced'],
			channels: 1,
			notifications: ['offline', 'device_problem', 'overpower', 'overvoltage', 'overtemperature'],
			slider: true,
			settings: roller_pro_pm_settings_gen_2,
		},
	},
};
